import React, { memo, FC, CSSProperties } from 'react';
import styled from '@emotion/styled';
import {
  Handle,
  Position,
  NodeProps,
  Connection,
  Edge,
} from 'react-flow-renderer';
import { useTranslation } from 'react-i18next';
import { useFormValCtx } from '@/context/FormValCtx';

const targetHandleStyle: CSSProperties = {
  background: 'transparent',
  border: 'none',
};
const sourceHandleStyleA: CSSProperties = { ...targetHandleStyle };
const sourceHandleStyleB: CSSProperties = { ...targetHandleStyle };

const onConnect = (params: Connection | Edge) =>
  console.log('handle onConnect', params);

const Box = styled.div`
  background: #f8cecc;
  border: solid 1px #b85450;
  margin: 5px;
  padding: 10px 20px;
  text-align: center;
  position: relative;
  width: 175px;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  .no {
    position: absolute;
    bottom: -30px;
    left: 55%;
  }
`;

const PFMT: FC<NodeProps> = ({ data, isConnectable }) => {
  const { t } = useTranslation();
  return (
    <Box style={{ marginTop: '80px' }}>
      <Handle
        type="target"
        position={Position.Bottom}
        style={targetHandleStyle}
        onConnect={onConnect}
      />
      <div>
        <span style={{ whiteSpace: 'nowrap' }}>{t('LifeStyle')} + </span>
        <br />
        {t('PFMT')}
        <span className="no">{t('No')}</span>
      </div>
    </Box>
  );
};

export default memo(PFMT);
